/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from 'react-infinite-scroll-component';
import Request from "../../utils/request";
import utils from "../../utils/utils";
import "./style.less";
import ItemView from './itemView';

class PipelineCommunityArticle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      hasMore: false,
      page: {
        pageNum: 1,
        pageSize: 20,
      },
    };
    this.sortTypeMap = {
      '自定义排序': 0,
      '点赞数降序': 1,
    };
    this.ref = null;
  }

  componentDidMount() {
    this.getCardListData();
  }

  componentWillReceiveProps(nexProps) {
    if (this.props.tabActive != nexProps.tabActive) {
      this.updateList();
    }
  }

  getCardListData() {
    const page = this.state.page;
    const itemList = this.props.config.itemList;
    const itemDataObj = {};
    const idList = itemList.map((item) => {
      if (item.id) {
        itemDataObj[item.id] = item;
      }
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    const reqUrl =
      "https://sh-gateway.shihuo.cn/v4/services/sh-gocommunity/x/v1/note/specially-list?test=skip";

    Request({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort: this.sortTypeMap[this.props.config.baseConfig.sortType] || 0,
        page: page.pageNum,
        page_size: page.pageSize,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.list || [];
        // 插入定制化内容
        list.forEach((card) => {
          try {
            const customItem = itemList.find((item) => item.id == card.id);
            if (customItem) {
              card.title = customItem.name || card.title;
              card.markText = customItem.markText;
            }
          } catch (error) {
            console.log('笔记组件数据遍历错误');
            const customItem_beta = itemDataObj[card.id];
            if (customItem_beta) {
              card.title = customItem_beta.name || card.title;
              card.markText = customItem_beta.markText;
            }
          }
        });
        const that = this;
        if (page.pageNum === 1) {
          this.setState({
            list,
            page,
          }, () => {
            that.updateList()
          });
        } else {
          this.setState({
            list: [...this.state.list, ...list],
            page,
          }, () => {
            that.updateList()
          });
        }

        page.pageNum += 1;

        // 判断是否还有下一页
        if (list.length >= page.pageSize) {
          this.setState({
            hasMore: true,
          })
        } else {
          this.setState({
            hasMore: false,
          })
        }
      }
    });
  }

  updateList() {
    this.isAnchorInSwitchTab = this.props['customAttributes']["data-component-belong"] === 'tab';
    const { baseConfig } = this.props.config;
    // 转为数字处理，后续参与计算
    baseConfig.itemMargin = isNaN(Number(baseConfig.itemMargin))  ? 0  : Number(baseConfig.itemMargin);
    if(typeof window !== "undefined"){
      if (!this.isAnchorInSwitchTab) {
        import('masonry-layout').then((Masonry)=>{
         this.ref && new Masonry(this.ref, {
            itemSelector: '.card-item', // 要布局的网格元素
            fitWidth: true, // 设置网格容器宽度等于网格宽度
            gutter: baseConfig.itemMargin,
          })
        }) 
      } else {
        const targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabIndex];
        targetTabContainer && import('masonry-layout').then((Masonry)=>{
          this.ref && new Masonry(this.ref, {
            itemSelector: '.card-item', // 要布局的网格元素
            fitWidth: true, // 设置网格容器宽度等于网格宽度
            gutter: baseConfig.itemMargin,
          })
        }) 
      }
    }
  }
  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      title: baseConfig.title,
      sort: index,
    };

    utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, item.id, this.props);
  }

  cardBannerGo = (url) => {
    // 商品banner跳转
    if (!url) {
      return;
    }
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      title: baseConfig.title,
      sort: 0
    };

    utils.jumpToUrl(this.props.routeParams, url, url, options, '', this.props);
  }



  render() {
    const { baseConfig } = this.props.config;
    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
    const articleList = this.state.list;
    // 转为数字处理，后续参与计算
    baseConfig.itemMargin = isNaN(Number(baseConfig.itemMargin))  ? 0  : Number(baseConfig.itemMargin);
    return (
      <div
        className="pipeline-communityArticle"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        {baseConfig.showTitle && (
          <div className="title" style={{ color: baseConfig.titleColor }}>
            {baseConfig.title}
          </div>
        )}
        {baseConfig.bannerImg && (
          <img
            className="card-banner"
            onClick={this.cardBannerGo.bind(this, baseConfig.bannerLink)}
            src={utils.formatImgUrl(baseConfig.bannerImg, this.props.webpSupport)}
            alt=""
          />
        )}
        <InfiniteScroll
          dataLength={articleList.length}
          next={this.getCardListData.bind(this)}
          hasMore={this.state.hasMore} className="list-1-container" style={{width: bodyWidth - Number(baseConfig.moduleMarginHorizon) * 2}}>
          <div className="list-1" ref={ref=>this.ref=ref}>
            {articleList.map((item, index) => {
              // 计算卡片宽度
              const cardImgWidth = (bodyWidth - Number(baseConfig.moduleMarginHorizon) * 2 - Number(baseConfig.itemMargin)) / 2;
              const { width, height } = item;
              let cardImgHeight = cardImgWidth
              let ratio = height / width
              ratio = Math.max(ratio, 3 / 4.0)
              ratio = Math.min(ratio, 4 / 3.0)
              cardImgHeight = cardImgWidth * ratio

              const itemStyle = {
                // width: itemWidth,
                width: cardImgWidth,
                marginTop: index > 1 ? `${baseConfig.itemMargin}px` : '0px',
                marginBottom: `${baseConfig.itemMargin / 2}px`,
              };
              // console.log('itemWidth', item.title, height / width, ratio);
              return (
                <ItemView
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, {
                    title: baseConfig.title,
                    sort: index,
                  }))}
                  key={'item-'+index}
                  handleItemClick={()=>{
                    this.handleItemClick(item, index)
                  }}
                  index={index}
                  itemStyle={itemStyle}
                  item={item}
                  cardImgHeight={cardImgHeight}
                />
              )
            })}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

PipelineCommunityArticle.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCommunityArticle };
export default PipelineCommunityArticle;



// WEBPACK FOOTER //
// ./components/pipeline-communityArticle/index.js